module.exports = __webpack_public_path__ + "static/scale-model-of-cowabunga-safaris-in-topeka-kansas-954da84aafbe423021d938d556045259.png";